/* Política informativa del tema. No modifica las tarifas de Shopify. */
(function () {
  'use strict';

  const isCents = value => Number.isSafeInteger(value) && value >= 0;

  function quote(total, config, now) {
    const active = config.enabled === true && config.currency === 'MXN' &&
      Number.isFinite(config.start) && config.start > 0 &&
      config.end === config.start + 30 * 24 * 60 * 60 &&
      now >= config.start && now < config.end;
    const valid = isCents(total);
    const rate = !valid || config.currency !== 'MXN' ? null : total >= config.free ? 0 :
      active && total >= config.minimum ? config.rate : null;
    return { active, rate, remaining: valid ? Math.max(0, config.free - total) : null };
  }

  // Fuente única para las barras de avance del carrito y del mini carrito. La
  // campaña conserva dos marcas mientras esté activa; fuera de ella sólo queda
  // el umbral de envío gratis.
  function progress(total, config, now) {
    const state = quote(total, config, now);
    const marks = state.active ? [config.minimum, config.free] : [config.free];
    const ceiling = marks[marks.length - 1];
    const safeTotal = isCents(total) ? total : 0;
    return {
      active: state.active,
      marks,
      state,
      percent: Math.max(0, Math.min(100, (safeTotal / ceiling) * 100))
    };
  }

  function formatMoney(cents) {
    if (!Number.isSafeInteger(cents)) return '$0';
    const absolute = Math.abs(cents);
    const whole = Math.floor(absolute / 100).toLocaleString('es-MX');
    const fraction = absolute % 100;
    return (cents < 0 ? '-$' : '$') + whole + (fraction ? '.' + String(fraction).padStart(2, '0') : '');
  }

  // Texto de cada marca de la barra del carrito: «$599 · envío $99» y
  // «$1,699 · gratis» durante la campaña; fuera de ella, sólo «$1,699».
  function markLabel(mark, config, active) {
    if (!active) return formatMoney(mark);
    return mark === config.minimum
      ? formatMoney(mark) + ' · envío ' + formatMoney(config.rate)
      : formatMoney(mark) + ' · gratis';
  }

  // Una cotización DHL sólo cuenta durante la campaña y en el tramo sin tarifa
  // fija: fuera de campaña manda el fallback aunque exista una cotización
  // previa. null nunca es gratis: known sólo es true para centavos confirmados.
  function resolve(total, config, now, quotedRate) {
    const state = quote(total, config, now);
    const rate = state.active && state.rate === null && isCents(quotedRate) ? quotedRate : state.rate;
    return Object.assign({}, state, { rate, known: isCents(rate) });
  }

  // Decisión D1 (S1.9, aprobada 2026-10-07). Fuente única de etiqueta e importe
  // para el resumen y la barra de pago fija del carrito. Bajo $1,699 el envío
  // depende del destino (DHL $140–$285, $99 o entrega local gratis) y lo calcula
  // el checkout: el importe es el subtotal y se rotula «Subtotal». Desde $1,699
  // el envío es gratis en todo México y ese mismo importe ya es el total. Ninguna
  // tarifa, fija o cotizada, se suma aquí; la fila de envío la sigue mostrando.
  function summary(total, state) {
    return { total, label: state.rate === 0 && state.remaining === 0 ? 'Total' : 'Subtotal' };
  }

  function cartMessage(total, state, config) {
    if (state.rate === 0) return '✓ ¡Envío nacional gratis! Tu pedido califica';
    if (state.rate === config.rate) return 'Envío nacional: $99 MXN. Te faltan ' + formatMoney(state.remaining) + ' para envío gratis.';
    if (state.known) return 'Envío nacional DHL: ' + formatMoney(state.rate) + ' MXN según tu dirección.';
    if (state.active) return 'Envío nacional DHL de $140 a $285 según tu estado. Agrega ' + formatMoney(Math.max(0, config.minimum - total)) + ' y tu envío baja a $99.';
    return 'Te faltan ' + formatMoney(state.remaining) + ' para envío nacional gratis desde $1,699.';
  }

  function rateFromDhl(response) {
    const rates = response && response.shipping_rates;
    if (!Array.isArray(rates)) return null;
    const dhl = rates.find(rate => /\bdhl\b/i.test(String(rate && (rate.company || rate.title || rate.name || ''))));
    if (!dhl || typeof dhl.price !== 'string' && typeof dhl.price !== 'number') return null;
    const text = String(dhl.price).trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null;
    const parts = text.split('.');
    const cents = Number(parts[0]) * 100 + Number((parts[1] || '').padEnd(2, '0'));
    return isCents(cents) ? cents : null;
  }

  // Exportar la misma función que usa la tienda permite comprobar límites y caducidad.
  if (typeof module === 'object' && module.exports) {
    module.exports = { quote, progress, formatMoney, markLabel, resolve, summary, cartMessage, rateFromDhl };
  }
  if (typeof document === 'undefined') return;
  const configNode = document.getElementById('en-shipping-policy-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }

  const nowSeconds = () => Date.now() / 1000;
  // La generación cambia con el importe canónico y con la vigencia. Una
  // cotización sólo se pinta si pertenece a la generación vigente.
  let cartTotal = null, policyActive = null, generation = 0, quoteEntry = null;

  function invalidateQuote() {
    generation += 1;
    quoteEntry = null;
  }

  // Devuelve true si la vigencia cambió desde la última comprobación.
  function syncPolicy() {
    const active = quote(0, config, nowSeconds()).active;
    if (active === policyActive) return false;
    policyActive = active;
    invalidateQuote();
    return true;
  }

  function current(total, now) {
    const entry = quoteEntry && !quoteEntry.pending && quoteEntry.generation === generation &&
      quoteEntry.total === total ? quoteEntry : null;
    return resolve(total, config, now, entry ? entry.rate : null);
  }

  function renderBar(total, state, now) {
    const bar = document.querySelector('[data-shipping-bar]');
    if (!bar) return;
    bar.className = 'en-shipping-bar';
    bar.removeAttribute('style');
    const text = document.createElement('div');
    text.className = 'en-shipping-text';
    text.textContent = cartMessage(total, state, config);
    if (state.rate === 0) {
      bar.classList.add('en-shipping-bar--success');
      bar.style.cssText = 'background:#1a3a1a;border:1px solid #2e7d32;border-radius:8px;padding:12px 16px;';
      text.style.cssText = 'color:#7fdd7f;font-weight:600;';
      bar.replaceChildren(text);
      return;
    }
    const data = progress(total, config, now);
    const ceiling = data.marks[data.marks.length - 1];
    const marks = document.createElement('div');
    marks.className = 'en-shipping-marks';
    marks.setAttribute('aria-hidden', 'true');
    data.marks.forEach(mark => {
      const label = document.createElement('span');
      label.className = 'en-shipping-mark';
      label.dataset.mark = String(mark);
      label.style.left = (mark / ceiling) * 100 + '%';
      label.textContent = markLabel(mark, config, data.active);
      marks.appendChild(label);
    });
    const track = document.createElement('div');
    const fill = document.createElement('div');
    track.className = 'en-shipping-track';
    fill.className = 'en-shipping-fill';
    fill.style.width = data.percent + '%';
    track.appendChild(fill);
    bar.replaceChildren(marks, track, text);
  }

  function renderSummary(total, state) {
    const node = document.querySelector('[data-en-shipping-summary]');
    if (!node) return;
    node.dataset.enShippingCartTotal = String(total);
    const amounts = summary(total, state);
    const subtotal = node.querySelector('[data-cart-subtotal]');
    const rate = node.querySelector('[data-shipping-value]');
    const totalEl = node.querySelector('[data-cart-total]');
    const label = node.querySelector('[data-en-shipping-total-label]');
    if (subtotal) subtotal.textContent = formatMoney(total);
    if (rate) {
      rate.textContent = state.rate === 0 ? 'GRATIS ✓' : state.rate === config.rate ? '$99 MXN'
        : state.known ? formatMoney(state.rate) + ' MXN' : 'Calculado en checkout';
      rate.style.color = state.rate === 0 ? '#7fdd7f' : '#595959';
      rate.style.fontWeight = state.rate === 0 ? '700' : '';
    }
    if (totalEl) totalEl.textContent = formatMoney(amounts.total) + ' MXN';
    if (label) label.textContent = amounts.label;
  }

  function render() {
    const now = nowSeconds();
    const active = quote(0, config, now).active;
    document.querySelectorAll('[data-en-shipping-trial]').forEach(el => { el.hidden = !active; });
    document.querySelectorAll('[data-en-shipping-base]').forEach(el => { el.hidden = active; });
    document.querySelectorAll('[data-en-shipping-drawer-total-label]').forEach(el => {
      el.textContent = active ? 'Subtotal de productos' : el.dataset.baseLabel;
    });
    // Sin total canónico (p. ej. fuera de /cart), cada aviso usa su propio importe.
    document.querySelectorAll('[data-en-shipping-quote]').forEach(el => {
      const amount = isCents(cartTotal) ? cartTotal : Number(el.dataset.enShippingCartTotal);
      if (isCents(amount)) el.textContent = cartMessage(amount, current(amount, now), config);
    });
    let state = null;
    if (isCents(cartTotal)) {
      state = current(cartTotal, now);
      renderBar(cartTotal, state, now);
      renderSummary(cartTotal, state);
    }
    // Los consumidores que dibujan marcas (mini carrito) se refrescan también
    // cuando caduca la política en una pestaña que permaneció abierta.
    document.dispatchEvent(new CustomEvent('energie:shipping-policy', { detail: { total: cartTotal, state } }));
  }

  function address() {
    const node = document.getElementById('en-shipping-address');
    if (!node) return null;
    try {
      const value = JSON.parse(node.textContent);
      return value && typeof value.zip === 'string' && value.zip.trim() &&
        typeof value.province === 'string' && value.province.trim() ? value : null;
    } catch (_) { return null; }
  }

  // Antes de aceptar una respuesta se vuelve a comprobar vigencia y generación.
  function finishQuote(entry, rate) {
    const policyChanged = syncPolicy();
    if (entry === quoteEntry && entry.generation === generation && quote(entry.total, config, nowSeconds()).active) {
      entry.pending = false;
      entry.rate = rate;
      render();
    } else if (policyChanged) {
      render();
    }
  }

  // Una solicitud por generación: ni duplicados en vuelo ni reintentos cada 30 s.
  function requestQuote(total) {
    if (quoteEntry) return;
    const state = current(total, nowSeconds());
    if (!state.active || state.rate !== null) return;
    const saved = address();
    if (!saved) return;
    const entry = quoteEntry = { generation, total, pending: true, rate: null };
    const params = new URLSearchParams({
      'shipping_address[zip]': saved.zip,
      'shipping_address[province]': saved.province,
      'shipping_address[country]': 'MX'
    });
    fetch('/cart/shipping_rates.json?' + params.toString(), { credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error('shipping rate unavailable');
        return response.json();
      })
      .then(data => finishQuote(entry, rateFromDhl(data)), () => finishQuote(entry, null));
  }

  function refresh(total) {
    syncPolicy();
    if (isCents(total)) {
      if (total !== cartTotal) invalidateQuote();
      cartTotal = total;
    } else if (!isCents(cartTotal)) {
      const node = document.querySelector('[data-en-shipping-summary]');
      const initial = node ? Number(node.dataset.enShippingCartTotal) : NaN;
      if (isCents(initial)) cartTotal = initial;
    }
    render();
    if (isCents(cartTotal)) requestQuote(cartTotal);
  }

  window.EnergieShipping = {
    quote: total => quote(total, config, nowSeconds()),
    state: total => current(total, nowSeconds()),
    progress: total => progress(total, config, nowSeconds()),
    formatMoney,
    // La barra de pago fija lo aplica al estado del evento energie:shipping-policy.
    summary,
    refresh,
    isKnown: total => current(total, nowSeconds()).known
  };
  refresh();
  document.addEventListener('cart:update', event => {
    if (!event.detail?.data?.didError) refresh(event.detail?.resource?.total_price);
  });
  // Renovar al volver de checkout y al cruzar el inicio/fin en una pestaña abierta.
  window.addEventListener('pageshow', () => refresh());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  setInterval(() => refresh(), 30000);
})();
